"use client";

import { cn } from "@/lib/utils";

interface TeacherAvatarProps {
  id: string;
  name: string;
  avatar?: string;
  size?: number;
  className?: string;
}

const THEME_COLORS: Record<string, string> = {
  xiaoya: "bg-amber-400 text-amber-950",
  zhiming: "bg-emerald-400 text-emerald-950",
  huixin: "bg-indigo-400 text-indigo-950",
  wenbo: "bg-amber-700 text-amber-50",
  xueshu: "bg-slate-400 text-slate-950",
};

export function TeacherAvatar({
  id,
  name,
  avatar,
  size = 96,
  className,
}: TeacherAvatarProps) {
  const initial = name.slice(0, 2);
  const color = THEME_COLORS[id] ?? "bg-slate-300 text-slate-900";

  if (avatar) {
    return (
      <img
        src={avatar}
        alt={name}
        width={size}
        height={size}
        className={cn("rounded-full object-cover", className)}
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full font-bold tracking-tight",
        color,
        className,
      )}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      aria-label={name}
    >
      {initial}
    </div>
  );
}
